<span class="au-brand-text"><slot /></span>

<style>
  .au-brand-text {
    font-family: var(--au-text-font-family-secondary);
    font-weight: var(--au-text-weight-bold);
    letter-spacing: normal;
  }
</style>
